<template>
  <div>
    <va-modal
      class="modal"
      v-model="showModal"
      max-width="100%"
      :hideDefaultActions="true"
      title="Gestion Abonnement Journal"
      v-on:cancel="closeModal"
      ><div class="forcewidth">
        <div class="row row-inside" v-if="infoEntreprise">
          <div class="flex md12"><h3>Entreprise</h3></div>
          <div class="flex md2 mr-4">{{ infoEntreprise.nom }}</div>
          <div class="flex md2 mr-4">{{ contactName(infoEntreprise) }}</div>
          <div class="flex md2">{{ infoEntreprise.adresse }}</div>
          <div class="flex md1">{{ infoEntreprise.code_postal }}</div>
          <div class="flex md1">{{ infoEntreprise.ville }}</div>

          <div class="flex md1">
            <va-toggle
              small
              v-model="infoEntreprise.subscribed === 1"
              @input="updateJournal()"
            />
          </div>
          <div class="flex md1">
            <va-checkbox
              label="Anonyme"
              v-model="infoEntreprise.dirigeant === 1"
              @input="updateHideDirigeant()"
            />
          </div>
          <div class="flex md12 mt-3 mb-2"><h3>Contacts</h3></div>
          <div class="flex md12" v-for="(contact, index) in infoContacts">
            <div class="row row-inside mb-3">
              <div class="flex md2 mr-4"></div>
              <div class="flex md2 mr-4">{{ contactNameExtract(contact) }}</div>
              <div class="flex md2">
                {{ contact.adresse_id ? contact.adresse : "" }}
              </div>
              <div class="flex md1">
                {{ contact.adresse_id ? contact.code_postal : "" }}
              </div>
              <div class="flex md1">
                {{ contact.adresse_id ? contact.ville : "" }}
              </div>

              <div class="flex md1">
                <va-toggle
                  small
                  v-model="contact.subscribed === 1"
                  @input="updateJournalContact(contact, index)"
                />
              </div>
              <div class="flex md1">
                <va-checkbox
                  :disabled="!contact.subscribed"
                  label="Entreprise visible"
                  v-model="contact.show_entreprise"
                  @input="updateShowEntreprise(contact)"
                />
              </div>
              <div class="flex md12 row-separator" />
            </div>
          </div>
        </div>
        <div class="row row-inside" v-else>Information non trouvées</div>
        <div class="row row-inside mt-4">
          <div class="flex md12"><h3>Adresses d'envois</h3></div>
          <va-card>
            <div
              class="row row-inside"
              v-for="(adresse, index) in adressesList"
            >
              <div class="flex md12" v-if="adressesList.length > 1">
                Adresse {{ index + 1 }}:
              </div>
              <div class="flex md12" v-if="adresse.nomEntreprise">
                {{ adresse.nomEntreprise }}
              </div>
              <div class="flex md12">{{ adresse.names }}</div>
              <div class="flex md12">{{ adresse.adresse }}</div>
              <div class="flex md12" v-if="adresse.complement">
                {{ adresse.complement }}
              </div>
              <div class="flex md12">
                {{ adresse.code_postal }} {{ adresse.ville }}
                {{ adresse.cedex }}
              </div>
              <div
                class="flex md12 mb-4"
                v-if="index < adressesList.length - 1"
              >
                <p></p>
              </div>
            </div>
          </va-card>
        </div>
        <div class="row row-inside mt-4">
          <div class="flex md12 mb-2"><h3>Notes</h3></div>
          <div
            v-show="!showModComment"
            class="flex md12"
            @click="displayCommentMod()"
          >
            <va-chip color="info" v-if="!infoEntreprise.note">
              Nouvelle note</va-chip
            >
            {{ infoEntreprise.note }}
          </div>
          <div v-show="showModComment" class="flex md12">
            <div class="row row-inside">
              <div class="flex md11">
                <va-input v-model="commentMod" type="textarea" autosize />
              </div>
              <div class="flex md1">
                <va-button
                  class="button-nm"
                  flat
                  small
                  color="primary"
                  icon="fa fa-save"
                  @click="saveComment()"
                />
                <va-button
                  flat
                  class="button-nm"
                  small
                  color="primary"
                  icon="fa fa-close"
                  @click="closeComment()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="close-button">
          <va-button class="fullwidth" @click="closeModal">Fermer</va-button>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { find } from "lodash";

export default {
  name: "gestion-journal-entreprise",
  props: ["value", "identreprise"],
  data() {
    return {
      showModal: false,
      adressesList: [],
      infoEntreprise: { note: "" },
      infoContacts: [],
      showModComment: false,
      commentMod: "",
    };
  },
  mounted() {
    this.showModal = this.value; // initialize internal variables
  },
  watch: {
    value(newValue) {
      console.log(newValue);
      // Parent property changed; update internal variables
      if (newValue === true) {
        this.loadInfos();
      }
      this.showModal = this.value;
    },
  },
  methods: {
    async saveComment() {
      // save comment if change
      if (this.infoEntreprise.note !== this.commentMod) {
        let params = {
          identreprise: this.infoEntreprise.identreprise,
          comment: this.commentMod,
        };
        let res = await axios.put(
          "/api/journal/entreprise/save-comment",
          params
        );
        this.infoEntreprise.note = res.data.note;
        this.showModComment = false;
        this.commentMod = "";
      } else {
        this.showModComment = false;
        this.commentMod = "";
      }
    },
    closeComment() {
      this.showModComment = false;
      this.commentMod = "";
    },
    displayCommentMod() {
      this.showModComment = true;
      this.commentMod = this.infoEntreprise.note;
    },
    async updateJournal() {
      // change subscription status

      try {
        let params = {
          identreprise: this.identreprise,
        };

        if (this.infoEntreprise.subscribed) {
          // case unsubscribe
          params.date_fin = moment().add(-1, "days").format("YYYY-MM-DD");
        } else {
          //case subscribe
          params.date_fin = "9999-01-01";
        }
        let value = await axios.post("/api/journal/entreprise/update", params);
        this.infoEntreprise = value.data;
        this.loadAdresses();
      } catch (error) {
        console.log(error);
      }
    },
    async updateJournalContact(item, index) {
      // change subscription status
      try {
        let params = {
          idcontact: item.idcontact,
          identreprise: this.infoEntreprise.identreprise,
        };

        if (item.subscribed) {
          // case unsubscribe
          params.date_fin = moment().add(-1, "days").format("YYYY-MM-DD");
        } else {
          //case subscribe
          params.date_fin = "9999-01-01";
        }
        let value = await axios.post(
          "/api/journal/entreprise/contact/update",
          params
        );
        let entrepriseInfos = value.data;
        this.infoContacts = entrepriseInfos.contacts;
        this.loadAdresses();
      } catch (error) {
        console.log(error);
      }
    },
    async updateShowEntreprise(contact) {
      try {
        let params = {
          idcontact: contact.idcontact,
        };

        if (contact.show_entreprise) {
          // case need to show dirigeant
          params.showEntreprise = true;
        } else {
          //case need to remove dirigeant
          params.showEntreprise = false;
        }
        let value = await axios.post(
          "/api/journal/entreprise/updateShowEntreprise",
          params
        );

        // update liste
        this.loadInfos();
        this.loadAdresses();
      } catch (error) {}
    },
    async updateHideDirigeant() {
      try {
        let params = {
          identreprise: this.identreprise,
          type: "entreprise",
        };

        if (this.infoEntreprise.dirigeant) {
          // case need to show dirigeant
          params.NotShowDirigeant = false;
        } else {
          //case need to remove dirigeant
          params.NotShowDirigeant = true;
        }
        let value = await axios.post(
          "/api/journal/entreprise/updateShowDirigeant",
          params
        );
        this.infoEntreprise = value.data;

        // update liste
        this.loadAdresses();
      } catch (error) {}
    },
    contactString(titre, nom, prenom) {
      let contactString = "";
      if (titre) {
        contactString = titre[0].toUpperCase() + titre.slice(1).toLowerCase();
      }

      if (nom) {
        contactString = contactString ? contactString + " " : "";
        contactString += nom.toUpperCase();
      }
      if (prenom) {
        contactString = contactString ? contactString + " " : "";
        contactString +=
          prenom[0].toUpperCase() + prenom.slice(1).toLowerCase();
      }

      return contactString;
    },
    contactNameExtract(contact) {
      if (!contact) {
        return;
      }
      // deal with the dirigeant being a société
      if (contact.titre && contact.titre === "SOCIÉTÉ") {
        return this.contactString(
          contact.titre_societe,
          contact.nom_societe,
          contact.prenom_societe
        );
      } else {
        return this.contactString(contact.titre, contact.nom, contact.prenom);
      }
    },
    contactName(infos) {
      try {
        let contact = find(this.infoContacts, {
          idcontact: infos.contact_idcontact,
        });

        return this.contactNameExtract(contact);
      } catch (error) {
        console.log(error);
        console.log("error retrieving the contact");
        return "";
      }
    },
    closeModal() {
      this.reset();
      this.$emit("close", false);
      this.$emit("input", false);
    },
    reset() {
      this.adressesList = [];
      this.showModComment = false;
      this.commentMod = "";
    },
    async loadInfos() {
      this.reset();
      if (this.identreprise) {
        try {
          let results = await axios.get("api/journal/status-entreprise", {
            params: { identreprise: this.identreprise },
          });

          this.infoEntreprise = results.data.entreprise;
          this.infoContacts = results.data.contact;

          this.infoContacts.forEach((item) => {
            if (!item.show_entreprise) {
              item.show_entreprise = false;
            }
          });

          this.loadAdresses();
        } catch (error) {}
        return;
      } else {
        this.launchToast("Entreprise inconnue");
        return;
      }
    },
    async loadAdresses() {
      try {
        let results = await axios.get("/api/journal/entreprise/adresses", {
          params: { identreprise: this.identreprise },
        });

        this.adressesList = results.data;
        console.log(results.data);
      } catch (error) {
        console.log(error);
      }
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 20vw;
  overflow: auto;
}

.fullwidth {
  width: 75%;
}

.close-button {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 10%;
}
</style>
